/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */

import { requestCurrentCloudBackupIfNotRequested } from 'state/current-cloud-backup/actions';
import { getCurrentCloudBackup, requestingCurrentCloudBackup } from 'state/current-cloud-backup/selectors';
import PlanLoader from './plan-loader';
import Icon from 'components/icon';
import Money from 'components/money';
import PlanName from 'components/plan-name';
import DateTime from 'components/date-time';
import Coupon from 'components/coupon';
import { Stack, Box, Divider, Text } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import SubscriptionStatus from 'components/subscription-status';
import Card from 'components/card';

/**
 * Style dependencies
 */
import './styles.scss';

const CurrentCloundBackupPlanCard = (props) => {
	let currentCloudBackup = props.currentCloudBackup;

	useEffect(() => {
		props.requestCurrentCloudBackup();
	}, []);

	if (!currentCloudBackup && !props.requesting) {
		return (
			<Card>
				<Card.Header heading='Plan details' />
				<Stack>
					<Card.Section>
						<DetailListItem label='Plan amount' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Current billing period' />
					</Card.Section>
					<Card.Section>
						<DetailListItem label='Next billing date' />
					</Card.Section>
				</Stack>
			</Card>
		);
	}

	if (!currentCloudBackup && props.requesting) {
		return <PlanLoader />;
	}

	return (
		<Stack space='xxlarge'>		
		    {currentCloudBackup.map((cloudBackupPlan) => {
		    	return (<Card><Stack><Card.Section>
							<Box display='flex' padding='small' alignItems='center'>
								<Stack space='small'>
									<Box>
										<PlanName value={cloudBackupPlan.plan_id} />
									</Box>
									<Box>
									    Price: 
										<Money value={cloudBackupPlan.plan_unit_price / 100} /> /{' '}
										{cloudBackupPlan.billing_period} {cloudBackupPlan.billing_period_unit}

										{cloudBackupPlan.setup_fee && (
										<Box>
											Setup Fee: 
											<Money value={cloudBackupPlan.setup_fee / 100} />
										</Box>
										)}
						         	</Box>

						         	{cloudBackupPlan.status == 'active' && (
						         	<Box>
									    Next Billing On <DateTime date={cloudBackupPlan.next_billing_at} />
						         	</Box>
						         	)}

								    {cloudBackupPlan.coupons && (
										<Box padding='small'>
											<Box marginBottom='medium'>
												<Text weight='medium' size='small'>
													Discounts
												</Text>
											</Box>
											<Stack space='medium' dividers>
												{cloudBackupPlan.coupons.map(({ coupon_id }) => {
													return (
														<Box key={coupon_id}>
															<Coupon couponId={coupon_id}></Coupon>
														</Box>
													);
												})}
											</Stack>
										</Box>
									)}
									<Box>
										<SubscriptionStatus status={cloudBackupPlan.status} />
									</Box>
									{cloudBackupPlan.status == 'future' && (
									<Box>
										Subscription start date: 
										{<DateTime date={cloudBackupPlan.start_date} format='Do MMM, YYYY' />}
						         	</Box>
						         	)}
						         	
								</Stack>
							</Box>
							
						</Card.Section></Stack></Card>)
		    })}
			
		</Stack>
	);
};

export default connect(
	(state) => ({
		currentCloudBackup: getCurrentCloudBackup(state),
		requesting: requestingCurrentCloudBackup(state),
	}),
	{
		requestCurrentCloudBackup: requestCurrentCloudBackupIfNotRequested,
	},
)(CurrentCloundBackupPlanCard);
